import {
  deleteApiV1ThreeLetterCodeClientAdminsClientNewslettersId,
  getPostApiV1ThreeLetterCodeClientAdminsClientNewslettersMutationKey,
} from '@fukuri-admins/apis/client/gen/endpoints';
import { useMutation } from '@fukuri-admins/hooks/common';
import { AxiosError } from 'axios';

/**
 * 社内報削除 API を実行するカスタムフック
 *
 * @param threeLetterCode - クライアントコード
 * @param options - コールバックオプション
 * @param options.onSuccess - 成功時のコールバック
 * @param options.onError - エラー時のコールバック
 */
export const useDeleteInternalNews = (
  threeLetterCode: string,
  options?: {
    onSuccess?: () => void;
    onError?: (error: AxiosError<{ errors?: string[] }>) => void;
  }
) => {
  return useMutation(
    getPostApiV1ThreeLetterCodeClientAdminsClientNewslettersMutationKey(threeLetterCode),
    (_, { arg }: { arg: number }) =>
      deleteApiV1ThreeLetterCodeClientAdminsClientNewslettersId(threeLetterCode, arg),
    options
  );
};
